module.exports = __webpack_public_path__ + "img/help-logo.65358345.png";